<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap pl-4>
      <v-flex lg6 sm6>
        <v-layout row wrap>
          <v-flex lg6 sm12 py-0>
            <v-autocomplete
              v-if="currentItem.ID == 0"
              label="Mã lô hàng"
              class="input-group--focused pt-0"
              :items="packages"
              v-model="currentItem.ID"
              item-text="PackageCode"
              item-value="ID"
              :disabled="readOnly"
              :rules="[(v) => !!v || 'Hãy nhập mã lô hàng']"
              @change="onChangePackage"
            >
            <template slot="no-data">
              <div>Không có dữ liệu lô hàng nhập kho</div>
            </template>
            </v-autocomplete>
            <v-text-field
              v-if="currentItem.ID > 0"
              label="Mã lô hàng"
              v-model="currentItem.PackageCode"
              class="input-group--focused pt-0"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <v-btn color="primary" @click="confirmImportAll" :disabled="!currentItem.ID">Nhập cả lô</v-btn>
            <!-- <v-checkbox label="Nhập kho toàn bộ lô hàng" v-model="currentItem.ImportAll"></v-checkbox> -->
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <v-text-field
              label="Ngày nhập kho"
              :value="currentItem.ImDate | display_date"
              class="input-group--focused font-weight-bold"
              readonly
            ></v-text-field>
          </v-flex>
          <v-flex lg6 sm12  py-0>
            <h-currency-input
              label="Tổng cước"
              v-model="currentItem.Amount"
              :decimal="0"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Số mã (TQ)"
              v-model="currentItem.TotalSmallPack"
              :decimal="0"
              class="input-group--focused"
              readonly
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Số mã đã nhập"
              v-model="currentItem.ReceivedPacks"
              :decimal="0"
              showClass="input-group--focused font-weight-bold text-red"
              color="red darken-2"
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Tổng cân nặng (TQ)"
              v-model="currentItem.Weight"
              :decimal="2"
              showClass="input-group--focused"
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Tổng cân nặng (VN)"
              v-model="currentItem.ReceivedWeight"
              :decimal="2"
              :disabled="!currentItem.ImportAll"
              showClass="input-group--focused font-weight-bold text-red"
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Tổng khối (TQ)"
              v-model="currentItem.Volume"
              :decimal="3"
              showClass="input-group--focused"
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 sm12 py-0>
            <h-currency-input
              label="Tổng khối (VN)"
              v-model="currentItem.ReceivedVolume"
              :decimal="3"
              :disabled="!currentItem.ImportAll"
              showClass="input-group--focused"
            ></h-currency-input>
          </v-flex>
          <v-flex lg6 md6 sm12 py-0>
            <v-checkbox label="Sử dụng máy đọc barcode" v-model="useBarcodeReader"></v-checkbox>
          </v-flex>
          <v-flex lg6 md6 sm12 py-0>
            <v-checkbox label="Xác nhận nhập kho khi MVĐ có cân nặng" v-model="markStoreImport"></v-checkbox>
          </v-flex>
          <v-flex lg12 md12 sm12 py-0>
            <v-autocomplete v-if="!useBarcodeReader" :disabled="readOnly || !currentItem.ID" label="Mã vận đơn" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="transactionCode" :search-input.sync="search" class="input-group--focused" @change="manualChanged"></v-autocomplete>
            <v-text-field
              v-else
              label="Mã vận đơn"
              ref="trancode"
              v-model.lazy="transactionCode"
              class="input-group--focused pt-0"
              @keyup.enter="manualChanged"
              :disabled="readOnly || !currentItem.ID"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg6 sm6>
        <v-data-table
          :headers="analytic_headers"
          :items="analytics"
          :items-per-page="6"
          :footer-props="{ 'items-per-page-options': [6, 10, 20] }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="font-weight-bold" style='color: #297801'>{{ item.Username || 'Vô chủ' }}</td>
              <td>{{ item.NumberOfPack | currency }}</td>
              <td>{{ item.ReceivedPacks | currency }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-layout row wrap pa-3>
      <v-flex lg12 md12 sm12 pa-0>
        <v-data-table
          :headers="headers"
          :items="currentItem.Packages"
          :options.sync="pagination"
          :server-items-length="totalPackage"
          :footer-props="items_per_page"
          
          :mobile-breakpoint="100"
          :must-sort="true"
          item-key="ID"
          show-select
          v-model="selected"
        >
          <template v-slot:item="{ item, isSelected, select, index }">
            <tr :id="'r-'+item.ID" :active="isSelected" v-bind:class="!item.ProductType ? 'error-tr' : ''">
              <td @click="select(!isSelected)" >
                <v-checkbox primary hide-details :input-value="isSelected"></v-checkbox>
              </td>
              <td v-bind:class="item.OrderID == null ? 'text-red' : ''">{{ item.TransactionCode }}</td>
              <td v-bind:style="{ 'color': get_status_color(item.Status, package_status)}">{{ item.Status | display_value(package_status) }}</td>
              <td>
                <v-select
                    :items="product_types"
                    v-model="item.ProductType"
                    item-text="Name"
                    item-value="ID"
                    @change="saveMultiple({'ID': item.ID, 'ProductType': item.ProductType, 'Status': item.Status, 'Weight': item.Weight})"
                ></v-select>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.NumberOfPack}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" label="Số kiện" v-model="item.NumberOfPack" :decimal="0" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, NumberOfPack: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, NumberOfPack: $event}, true)"></h-currency-input>
              </td>
              <td v-if="!item.OrderID">Vô chủ</td>
              <td v-else>
                <a target="_blank" :href="(!item.PackageType ? '/don-hang/chi-tiet/' : '/ky-gui/') + item.OrderID">{{(!item.PackageType == 1 ? 'MD' : 'KG') + item.OrderID}}</a>
              </td>
              <td class="font-weight-bold" style='color: #297801'>{{ item.Username || 'Vô chủ' }}</td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Weight}}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" :ref="'tranweight'+index" :id="'tranweight'+index" label="Cân nặng" v-model="item.Weight" :decimal="2" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Weight: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Weight: $event}, true)"></h-currency-input>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Length | currency('', 2) }}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" label="Chiều dài (cm)" v-model="item.Length" :decimal="2" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Length: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Length: $event}, true)"></h-currency-input>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Width | currency('', 2) }}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" label="Chiều rộng (cm)" v-model="item.Width" :decimal="2" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Width: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Width: $event}, true)"></h-currency-input>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Height | currency('', 2) }}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" label="Chiều cao (cm)" v-model="item.Height" :decimal="2" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Height: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Height: $event}, true)"></h-currency-input>
              </td>
              <td class="text-end" v-if="item.Status == 5">{{ item.Volume | currency('', 3) }}</td>
              <td class="text-end" v-if="item.Status != 5">
                <h-currency-input :autoEmit="false" label="Số khối" v-model="item.Volume" :decimal="3" showClass="input-group--focused" @on_blur="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Volume: $event})" @press_enter="saveTranWeight({ID: item.ID, ProductType: item.ProductType, Volume: $event}, true)"></h-currency-input>
              </td>
              <td class="text-end">{{ item.WeightByVolume}}</td>
              <td class="truncate">
                <v-edit-dialog
                :return-value.sync="item.StoreVNNote"
                lazy
                @save="saveNoteItem(item)"
                >
                    <v-tooltip max-width="250" color="light-green lighten-5 black--text">
                        <template v-slot:activator="{ on }">
                            <span v-on="on">{{ item.StoreVNNote }}</span>
                        </template>
                        <span>{{ item.StoreVNNote }}</span>
                    </v-tooltip>
                    <template v-slot:input>
                        <v-text-field
                        v-model="item.StoreVNNote"
                        label="Ghi chú"
                        autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
              </td>
              <td class="text-center">
                <v-icon medium class="mr-2" color="red darken-2" @click="printTransaction(item.ID, item.PackageType)">fa-print</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
     <v-dialog v-model="showDialogTrancode" max-width="300px">
      <v-card>
        <v-card-title>
          <span class="title">Mã vận đơn</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md pa-0>
            <v-layout row wrap>
              <v-flex lg12>
                <v-text-field label="Mã vận đơn" v-model="newTransactionCode"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="showDialogTrancode = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="saveNewTrancode">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCreateDeposit" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="title">Khớp đơn</span>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="r_option" row>
            <v-radio label="Đơn ký gửi" value="r-deposit"></v-radio>
            <v-radio label="Đơn mua hộ" value="r-order"></v-radio>
          </v-radio-group>
          <v-layout row wrap v-if="r_option == 'r-deposit'">
            <v-flex lg12 pl-3 pr-3>
              <v-autocomplete label="Khách hàng" v-model="selectedCustomerID" :items="customers" :item-text="getCustomerText" item-value="ID"></v-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap v-else>
            <v-flex lg12 pl-3 pr-3>
              <v-autocomplete label="Đơn hàng" v-model="selectedOrderID" :items="matchOrders" :item-text="getOrderText" item-value="ID"></v-autocomplete>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1 white--text" @click="dialogCreateDeposit = false">Đóng</v-btn>
          <v-btn color="red darken-1 white--text" @click="onCreateDepositOrder">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
import { print_transaction_v2, request_detail } from "@/commons/hpod";
import Vue from 'vue';
import { getCurrentTime, sendErrorNotice, sendDialogNotice, playUIDSound, playSound } from "@/commons/utils";
export default {
  data() {
    return {
      r_option: 'r-deposit',
      selected: [],
      dialogCreateDeposit: false,
      selectedCustomerID: 0,
      selectedOrderID: 0,
      appLoading: false,
      disable_sort: false,
      useBarcodeReader: true,
      markStoreImport: false,
      transactionCode: "",
      queryTerm: '',
      package_status: configs.PACKAGE_STATUS,
      analytic_headers: [
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Đã nhận",
          value: "ReceivedPacks",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        }
      ],
      headers: [
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
            text: "Trạng thái",
            value: "Status",
            filterable: true,
            dataType: configs.DATA_TYPE["Enum"],
            values: configs.PACKAGE_STATUS
        },
        {
          text: "Loại hàng",
          value: "ProductType",
          filterable: true,
          dataType: configs.DATA_TYPE["Enum"],
          values: []
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Order ID",
          value: "OrderID",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Khách hàng",
          value: "Username",
          quickSearch: true,
          filterable: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Cân nặng",
          value: "Weight",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều dài (cm)",
          value: "Length",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều rộng (cm)",
          value: "Width",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Chiều cao (cm)",
          value: "Height",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Khối",
          value: "Volume",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Cân quy đổi",
          value: "WeightByVolume",
          filterable: true,
          dataType: configs.DATA_TYPE["Number"]
        },
        {
          text: "Ghi chú",
          value: "StoreVNNote",
          filterable: true,
          quickSearch: true,
          dataType: configs.DATA_TYPE["String"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: { ...configs.PAGINATION, sortBy: ["ModifiedDate"], sortDesc: [true], itemsPerPage: 20},
      items_per_page: { "items-per-page-options": [20, 30, 50, 100, 200, 500] },
      currentTime: getCurrentTime(),
      showDialogTrancode: false,
      newTransactionCode: ''
    };
  },
  props: ["dialogPackageDetail", "readOnly"],
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        this.refreshData();
      },
      deep: true
    },
    packageId() {
      if(this.packageId > 0) {
        this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
            Pid: this.packageId,
            title: "Chi tiết nhập kho"
          }
        });
        this.refreshData();
      }
      this.appLoading = false;
    },
    product_types() {
      let header_item = _.find(this.headers, { value: "ProductType" });
      if (header_item) {
          header_item.values = _.map(this.product_types, (item) => {
              return {
                  value: item.ID,
                  name: item.Name
              }
          }) || []
      }
    },
    // currentItem() {
    //   if(this.currentItem && this.currentItem.Packages.length == 1 && this.transactionCode != '') {
    //     const uid = this.currentItem.Packages[0].UID;
    //     playUIDSound(uid);
    //   }
    // }
  },
  computed: {
    ...mapState({
      currentItem: state => state.bigPackage.selected,
      totalPackage: state => state.bigPackage.selected.TotalPackage || 0,
      loading: state => state.bigPackage.loading,
      trancodeDetail: state => state.bigPackage.trancodeDetail,
      packages: state => state.bigPackage.notTransit,
      suggestList: state => _.sortBy(state.orderTransaction.suggestList.data, 'UID'),
      product_types: state => state.productType.all.data,
      customers: state => state.customer.master.data,
      matchOrders: state => state.main_order.matchOrders.data,
    }),
    search: {
      get () {
        return this.queryTerm
      },
      set (searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
    packageId() {
      return this.currentItem && this.currentItem.ID > 0
        ? this.currentItem.ID
        : Number(this.$route.params.Pid);
    },
    trancode_param() {
      let param = {};
      if(this.transactionCode || this.queryTerm) {
        param['trancode'] = this.transactionCode == '' ? this.queryTerm : this.transactionCode;
      }
      return param;
    },
    analytics() {
      let result = [];
      this.suggestList.reduce(function(res, value) {
        if (!res[value.UID]) {
          res[value.UID] = { Username: value.Username, NumberOfPack: 0, ReceivedPacks: 0 };
          result.push(res[value.UID])
        }
        res[value.UID].NumberOfPack += value.NumberOfPack;
        if(value.Status == 4 || value.Status == 5) {
          res[value.UID].ReceivedPacks += value.NumberOfPack;
        }
        return res;
      }, {});
      return result;
    }
  },
  mounted() {
    this.$store.dispatch("main_order/getMatchOrders");
    this.refreshData();
    this.getListPackageNotTran();
    this.$store.dispatch("customer/getCustomerList", {
      is_master: 1,
      fields: ["ID", "Username", "ReceivePlaceID", "ChinaStoreID"]
    });
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.getSuggestList);
    this.$root.$on("REQUEST_OTHER_ACTION", this.createDepositOrder);
    this.$root.$on("CONFIRMED_ACTION", ({action, id}) => {
      if(action == 'ImportAll') {
        this.currentItem.ImportAll = 1;
        this.saveData();
      }
    });
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_SAVE_DATA");
    this.$root.$off("REQUEST_REFRESH_DATA");
    this.$root.$off("REQUEST_OTHER_ACTION");
    this.$root.$off("CONFIRMED_ACTION");
  },
  methods: {
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    printTransaction(id, package_type) {
      request_detail('order_transactions/print', ret => {
          let item = ret.data;
          print_transaction_v2(item);
      }, Vue.http, id, this.$store.state.authentication.token, {'PackageType': package_type});
    },
    manualChanged() {
      if(this.transactionCode) {
        const trancode = `${this.transactionCode}.`;
        this.$store.dispatch("orderTransaction/setDetail", {'data': {'TransactionCode': this.transactionCode, 'Action': 'store_vn_import'}, 'id': 999999999}).then((p) => {
          if(p.status == 200) {
            const uid = p.data.UID;
            playUIDSound(uid);
          }
          else if(p.data.data) {
            const uid = p.data.data.UID;
            playUIDSound(uid);
          }
          this.refreshData();
          this.$store.dispatch("orderTransaction/getList", {filter: [{ column: "TransactionCode", value: trancode, condition: "contain" }]}).then(p => {
            if(p.data.length > 0) {
              sendDialogNotice('Mã vận đơn có chứa mã tách, hãy kiểm tra lại.');
              this.playSound('/fire_alarm.mp3');
            }
          });
        });
      }
      else {
        this.refreshData();
      }
    },
    confirmImportAll() {
      window.getApp.$emit("REQUEST_CONFIRM_ACTION", 'ImportAll', this.currentItem.ID, `Bạn có chắc chắn nhập toàn bộ lô hàng không?`);
    },
    getSuggestList() {
      if(this.packageId) {
        this.$store.dispatch("orderTransaction/getListSuggest", {filter: [
          {
            column: "BigPackageID",
            value: this.packageId,
            condition: "equal",
          }
        ]});
      }
      else {
        this.$store.commit("orderTransaction/setListSuggest", {data: []});
      }
    },
    refreshData() {
      this.$store.dispatch("productType/getList");
      this.$store.commit("orderTransaction/setListSuggest", {data: []});
      if (this.packageId) {
        this.$store.dispatch("bigPackage/getDetail", {'id': this.packageId, 'param': {...this.trancode_param, pagination: this.pagination}}).then(p => {
          if(this.transactionCode || this.queryTerm) {
            if(!p.Packages[0].Weight || !this.markStoreImport) {
              setTimeout(() => {
                // document.getElementById("tranweight0").focus();
                // document.getElementById("tranweight0").select();
                this.$refs.tranweight0.$el.querySelector('input').focus();
                this.$refs.tranweight0.$el.querySelector('input').select();
                p.Packages[0].Weight = 0;
              }, 300);
            }
            else {
              this.$nextTick(() => {
                this.$refs.trancode.$el.querySelector('input').focus();
                this.$refs.trancode.$el.querySelector('input').select();
              });
            }
          }
          else {
            this.$nextTick(() => this.$refs.trancode.focus());
          }
        });
        this.getSuggestList();
        this.selected = [];
      }
    },
    onChangePackage(value) {
      this.appLoading = true;
      let selectedItem = _.find(this.packages, { ID: value });
      if (selectedItem) {
        this.currentItem.PackageCode = selectedItem.PackageCode;
      }
      this.saveData();
    },
    getListPackageNotTran() {
      this.$store.dispatch("bigPackage/getListNotTransit");
    },
    saveMultiple(item) {
      let transaction_ids = _.map(this.selected, "ID");
      let payload = {
        TransactionIDs: transaction_ids,
        ProductType: item.ProductType
      };
      if(transaction_ids.length == 0) {
        payload.TransactionIDs.push(item.ID);
        payload.Status = item.Status < 4 && item.Weight > 0 ? 4 : item.Status
      }
      if(transaction_ids.length > 0) {
        this.$store.dispatch("orderTransaction/updateMultiple", payload).then(p => {
          this.refreshData();
        });
      }
      else {
        this.saveTranWeight(item);
      }
    },
    saveTranWeight: _.debounce(
        function(item, moveToTrans = false) {
          if(!item.ProductType) {
            sendErrorNotice('Hãy nhập thông tin LOẠI HÀNG.');
            return;
          }
          var data = {
            ...item,
            TransactionView: 'store_vn'
          };
          data.ModifiedBy = this.$store.state.authentication.user.username;
          this.$store.dispatch("orderTransaction/setDetail", { 'data': data, 'id': item.ID, 'param': {...this.trancode_param, pagination: this.pagination}}).then(p => {playSound('/success.mp3');});
          if(moveToTrans) {
            this.$nextTick(() => this.$refs.trancode.focus());
            this.transactionCode = "";
            this.search = "";
          }
        },
        300,
        {
            leading: true,
            trailing: false
        }
    ),
    saveNoteItem(item) {
      this.$store.dispatch("orderTransaction/setDetail", {'data': {'StoreVNNote': item.StoreVNNote, 'TransactionView': 'store_vn'}, 'id': item.ID});
      this.$nextTick(() => this.$refs.trancode.focus());
      this.transactionCode = "";
      this.search = "";
    },
    createData(username = "") {
      this.getListPackageNotTran();
      this.$store.commit("bigPackage/setDetail", {
        data: {
          ID: 0,
          PackageCode: '',
          Weight: 0,
          Volume: 0,
          Amount: 0
        }
      });
      this.$router.push({
          name: "StoreManagerVNDetail",
          params: {
          Pid: 'nhap-bao-moi',
          title: 'Nhập lô mới'
          }
      });
    },
    saveData() {
      this.$store.dispatch("bigPackage/setDetail", {
        data: {
          ReceivedWeight: this.currentItem.ReceivedWeight,
          ReceivedVolume: this.currentItem.ReceivedVolume,
          RealWeight: this.currentItem.RealWeight,
          ReceivedPacks: this.currentItem.ReceivedPacks,
          ImportAll: this.currentItem.ImportAll,
          Status: configs.BIG_PACKAGE_STATUS_ENUM.DA_NHAN
        },
        id: this.currentItem.ID
      }).then(r => {this.refreshData();});
      this.appLoading = false;
      this.$nextTick(() => this.$refs.trancode.focus());
      this.transactionCode = "";
      this.search = "";

    },
    dialogTrancode() {
      this.showDialogTrancode = true;
    },
    saveNewTrancode() {
      this.$store.dispatch("bigPackage/addNewTrancode", {'tran_code': this.newTransactionCode, 'package_id': this.packageId, 'param': {...this.trancode_param, pagination: this.pagination}});
      this.newTransactionCode = '';
      this.showDialogTrancode = false;
    },
    getCustomerText(item) {
      return `DL${item.ID} - ${item.Username}`
    },
    getOrderText(item) {
      return `${item.OrderCode} (${item.UserCode})`
    },
    onCreateDepositOrder() {
      let rightSeleted = _.filter(this.selected, (p) => {return !p.OrderID;});
      if(rightSeleted.length == 0) {
        sendErrorNotice("Hãy chọn danh sách mã vận đơn chưa khớp đơn!");
        return;
      }
      if(this.r_option == 'r-deposit') {
        let newOrder = {Status: 16};
        if(this.selectedCustomerID == 0) {
          sendErrorNotice("Hãy chọn khách hàng!");
          return;
        }
        const cust = _.find(this.customers, {'ID': this.selectedCustomerID});
        newOrder.UID = this.selectedCustomerID;
        newOrder.Username = cust.Username;
        newOrder.ReceivePlaceID = cust.ReceivePlaceID;
        newOrder.ChinaStoreID = cust.ChinaStoreID;
        newOrder.CustomerServiceID = cust.CustomerServiceID;
        newOrder.TransactionIDs = _.map(rightSeleted, "ID")

        this.$store.dispatch("deposit/setDetail", {'data': newOrder}).then(r => {this.refreshData();});
      }
      else {
        if(this.selectedOrderID == 0) {
            sendErrorNotice("Hãy chọn đơn hàng!");
            return;
        }
        this.$store.dispatch("orderTransaction/updateMultiple", {
          TransactionIDs: _.map(rightSeleted, "ID"),
          OrderID: this.selectedOrderID,
          PackageType: 0
        }).then(p => {this.refreshData();});
      }
      this.selected = []
      this.dialogCreateDeposit = false;
    },
    createDepositOrder() {
      this.dialogCreateDeposit = true;
      this.selectedCustomerID = 0;
    },
  }
};
</script>